'use client';

import { useEffect } from 'react';
import { trackViewItem } from '@/service/GA4/ga4Events';
import { usePartnerStore } from '@/service/state/Partner/usePartnerStore';
import { trackProductDetailCRS } from '../CRS/crsEvents';
import { URLs } from '../constants/urls';
import { trackFBPixelEvent } from '../FBpixel/FBpixel';

type TTrackViewEvent = {
    viewItem: {
        id: string;
        name: string;
        category: string;
        price: number;
        quantity: number;
    };
};

export const TrackViewItemGAEvent = ({ viewItem }: TTrackViewEvent) => {
    const { title, siteurl } = usePartnerStore((state) => state);

    useEffect(() => {
        if (title && siteurl) {
            trackViewItem({
                currency: 'USD',
                value: viewItem.price,
                items: [
                    {
                        item_id: viewItem.id,
                        item_name: viewItem.id,
                        affiliation: title,
                        item_brand: title,
                        item_category: viewItem.category,
                        price: viewItem.price,
                        quantity: viewItem.quantity,
                    },
                ],
            });

            trackProductDetailCRS({
                activityId: +viewItem.id,
                brand: siteurl,
                imageUrl: `${URLs.image}/activity/${viewItem.id}/center/676x489/wr.jpg`,
                name: viewItem.name,
                path: `/${siteurl}/details/${viewItem.id}`,
                price: viewItem.price,
            });

            trackFBPixelEvent('ViewContent', {
                content_ids: [viewItem.id],
                content_type: 'product',
                currency: 'USD',
                content_name: viewItem.name,
                value: viewItem.price,
                contents: [{ id: viewItem.id, quantity: viewItem.quantity }],
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title, siteurl]);

    return <></>;
};
